import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import { EmailUserDto, MailTemplateDto, RequestSendMassMailDto, ResponseSendMassMailDto, UserDto } from "../account/account.dto";
import { SurveyResultsResponse } from "../forms/form.dto";
import { CreateReportDto, CreateVideoDto, ReportDto, VideoDto } from "./admin.dto";
import { PresidentMessageDto, UpdatePresidentMessageDto } from "./admin.dto";

const services = {
  GetUser(id: string, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<UserDto>(`admin/getuser/${id}`, config);
  },
  GetAllUser(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<UserDto[]>(`admin/getalluser`, config);
  },
  GetAllMainUsers(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<UserDto[]>(`Admin/GetAllMainUsers`, config);
  },

  MakeOsbukUser(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<string>(`admin/makeosbukuser/${id}/`, config);
  },

  GetSurveyResults(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<SurveyResultsResponse>("admin/survey-results", config);
  },

  getUserForMassEmail(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<EmailUserDto>("admin/mass-email-users", config);
  },

  sendMassEmail(dto: RequestSendMassMailDto | FormData, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<ResponseSendMassMailDto>("admin/send-mass-email", dto, config);
  },

  getMailTemplates(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<MailTemplateDto[]>("admin/mail-templates", config);
  },

  createMailTemplate(dto: Omit<MailTemplateDto, "id">, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<MailTemplateDto>("admin/mail-templates", dto, config);
  },

  deleteMailTemplate(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.delete<string>(`admin/mail-templates/${id}`, config);
  },

  // Video endpoints
  getVideos(type: string, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<VideoDto[]>(`/pages/videos/?type=${type}`, config);
  },

  createVideo(dto: CreateVideoDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<string>("/pages/videos/", dto, config);
  },

  updateVideo(id: number, data: any, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<string>(`/pages/videos/${id}/`, data, config);
  },

  deleteVideo(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.delete<string>(`/pages/videos/${id}/`, config);
  },

  async getPresidentMessage() {
    return await http.get<PresidentMessageDto>("/pages/president-message/");
  },

  async updatePresidentMessage(data: UpdatePresidentMessageDto) {
    const message = await this.getPresidentMessage();
    if (message?.result?.data) {
      return await http.put<PresidentMessageDto>(`/pages/president-message/${message.result.data.id}/`, data);
    }
    return await http.post<PresidentMessageDto>("/pages/president-message/", data);
  },

  // Report endpoints
  getReports(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ReportDto[]>(`/pages/reports/`, config);
  },

  createReport(dto: CreateReportDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<string>("/pages/reports/", dto, config);
  },

  updateReport(id: number, data: any, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<string>(`/pages/reports/${id}/`, data, config);
  },

  deleteReport(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.delete<string>(`/pages/reports/${id}/`, config);
  },

  downloadReport(id: number) {
    return http.get(`/pages/reports/${id}/download/`, {
      responseType: "blob"
    });
  }
};

export default services;
